import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { track } from "../lib/analytics";
import { scrollToId } from "./SmoothScroll";

// CTA sticky mobile : apparaît après le hero, disparaît quand le formulaire final est visible.
export default function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero");
    const finalForm = document.getElementById("final-form");
    let heroOut = false;
    let finalIn = false;

    const update = () => setVisible(heroOut && !finalIn);

    const obs = [];
    if (hero) {
      const io = new IntersectionObserver(
        ([e]) => {
          heroOut = !e.isIntersecting;
          update();
        },
        { threshold: 0, rootMargin: "-80px 0px 0px 0px" }
      );
      io.observe(hero);
      obs.push(io);
    }
    if (finalForm) {
      const io2 = new IntersectionObserver(
        ([e]) => {
          finalIn = e.isIntersecting;
          update();
        },
        { threshold: 0.15 }
      );
      io2.observe(finalForm);
      obs.push(io2);
    }
    return () => obs.forEach((o) => o.disconnect());
  }, []);

  const go = () => {
    track("sticky_cta_click");
    scrollToId("#final-form");
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="sticky-cta"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          data-testid="sticky-cta"
        >
          <button className="btn btn--primary btn--full" onClick={go} data-testid="sticky-cta-btn">
            JE REJOINS LA TRAVERSÉE
            <ArrowRight size={18} strokeWidth={1.8} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
